import { AxiosPromise } from "axios";
import { request } from "utils/request";

export const configurationApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/configuration",
      params,
    }),
  update: (id: number, data: { value: string }): AxiosPromise<any> =>
    request({
      url: `/v1/admin/configuration/${id}`,
      method: "patch",
      data,
    }),
};
